<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user}">User</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">条件名</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex">
      <button @click="postCondition" style="width: 150px"><i class="fa fa-fw fa-plus"></i></button>
      <input v-model="add.name" type="text" placeholder="条件名" style="border: solid 1px #ccc; width: 150px; margin: 1px; padding: 10px">
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>User</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>条件名</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in orderedConditions" :key="index.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelCondition(list)" class="del" style="position: relative">キャンセル</td-c>
            <td-c @click.native="patchCondition(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="name"><td-c style="border: solid 3px #337bc4"><input type="text" v-model="list.name" style="font-weight: bold"></td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteCondition(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editCondition(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="name"><td-c>{{list.name}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/conditions/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'condition',
  pageNames: 'conditions'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',

      id: true,
      user: true,
      name: true,
      created_at: true,

      search: {
        id: '',
        user: '',
        name: '',
        created_at: '',

        not_id: '',
        not_user: '',
        not_name: '',
        not_created_at: ''
      },

      add: {
        name: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    conditions () {
      return this.$store.getters.conditions
    },

    orderedConditions () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.conditions, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.conditions, this.desc).reverse()
      }
    }
  },
  methods: {
    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.user = false
      this.name = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.user = true
      this.name = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    editCondition (list) {
      this.$store.dispatch('editCondition', {
        edit_id: this.edit_id,
        list: list
      })
    },

    postCondition () {
      this.$store.dispatch('postCondition', this.add)
    },

    deleteCondition (list) {
      this.$store.dispatch('deleteCondition', list)
    },

    cancelCondition () {
      this.$store.dispatch('cancelCondition', {
        edit_id: this.edit_id
      })
    },

    patchCondition (list) {
      this.$store.dispatch('patchCondition', {
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 200px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// ConditionsIndex.vue?6a437540